"use client"
import React, { useState, useRef, useEffect } from "react"
import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';

import ModalForm from "../general-component/modalBanner";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";

const Header: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpen, setISOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownNursingOpen, setDropdownNursingOpen] = useState(false);
  const [dropdownNew, setDropdownNew] = useState(false);
  const [mbbsdrop, setMbbsDrop] = useState(false);
  const [nursingdrop, setNursingDrop] = useState(false);
  const [pharmacydrop, setPharmacyDrop] = useState(false);
  const [dropdownPharmacyOpen, setDropdownPharmacyOpen] = useState(false);
  const [othersDrop, setOthersDrop] = useState(false);
  const pathname = usePathname();
  const [id, setId] = useState('');

  const ismbbs = pathname.startsWith("/study-mbbs-abroad")
  const dropdownRef = useRef<HTMLDivElement>(null);
  const dropdownNursingRef = useRef<HTMLDivElement>(null);
  const mobileMbbsRef = useRef<HTMLLIElement>(null);
  const mobileNursingRef = useRef<HTMLLIElement>(null);
  const mobilePharmacyRef = useRef<HTMLLIElement>(null);
  const dropdownPharmacyRef = useRef<HTMLDivElement>(null);
  const mobileOthersRef = useRef<HTMLLIElement>(null);
  const desktopOthersRef = useRef<HTMLDivElement>(null);

  const dropdown = () => {
    setISOpen(!isOpen);
  }

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const toggleMbbs = () => {
    setMbbsDrop(!mbbsdrop);


  }

  const toggleNursingDropdown = () => {
    setDropdownNursingOpen(!dropdownNursingOpen);
  };

  const toggleNursing = () => {
    setNursingDrop(!nursingdrop);
  }

  const togglePharmacyDropdown = () => {
    setDropdownPharmacyOpen(!dropdownPharmacyOpen);
  };

  const togglePharmacy = () => {
    setPharmacyDrop(!pharmacydrop);
  }

  const toggleOthers = () => {
    setOthersDrop(!othersDrop);

  }

  const toggleNew = () => {
    setDropdownNew(!dropdownNew);
  }


  useEffect(() => {
    const basePath = 'Apply_Now_';
    if (pathname == '/') {

      const finalPath = basePath + 'Home';

      setId(finalPath);
    }
    else {
      const data = pathname.split('/')[1];
      const finalPath = basePath + data;
      setId(finalPath);
    }
  }, [pathname])


  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {

      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }

      if (dropdownNursingRef.current && !dropdownNursingRef.current.contains(event.target as Node)) {
        setDropdownNursingOpen(false);
      }

      if (desktopOthersRef.current && !desktopOthersRef.current.contains(event.target as Node)) {
        setDropdownNew(false);
      }


      if (mobileMbbsRef.current && !mobileMbbsRef.current.contains(event.target as Node)) {
        setMbbsDrop(false);
      }

      if (mobileNursingRef.current && !mobileNursingRef.current.contains(event.target as Node)) {
        setNursingDrop(false);
      }

      if (mobilePharmacyRef.current && !mobilePharmacyRef.current.contains(event.target as Node)) {
        setPharmacyDrop(false);
      }

      if (mobileOthersRef.current && !mobileOthersRef.current.contains(event.target as Node)) {
        setOthersDrop(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 flex items-center justify-between px-7 py-1 sm:px-20 sm:py-2 bg-white shadow-md z-50">
      <div className="hidden xl:flex xl:justify-center xl:items-center">
        <Link href="/">
          <img src="/educaficlogo.png" style={{ width: "90px" }} alt="logo" />
        </Link>
      </div>

      <div className='block xl:hidden cursor-pointer' onClick={dropdown}>
        <FaBars className='text-[30px] text-teal-500' />
      </div>

      <div className={`fixed overflow-y-auto z-50 top-0 left-0 w-1/2 sm:w-1/3 h-full bg-gradient-to-br from-blue-500 to-teal-500 text-white shadow-lg flex flex-col items-start p-4 sm:p-6 space-y-6 rounded-r-2xl transform transition-transform duration-500 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="w-full flex justify-between items-center mb-4">
          <Link href="/">
            <img src="/educaficlogowhite.png" width={150} height={100} alt="logo" onClick={() => setISOpen(!isOpen)} />
          </Link>
          <FaTimes className="text-[30px] max-sm:mt-[-20px] max-sm:left-[8px] cursor-pointer text-base" onClick={dropdown} />
        </div>
        <ul className="w-full space-y-4">
          {[
            { href: "/", label: "Home", icon: "/Home/home.svg" },
            { href: "/courses", label: "Courses", icon: "/Home/courses.svg" },
            { href: "/destination", label: "Destination", icon: "/Home/destination.svg" },
            { href: "/neet-result-2025", label: "NEET Exam 2025", icon: "/Home/blogs.svg" },
          ].map((link) => (
            <li key={link.href}>
              <Link
                href={link.href}
                title={link.label}
                className={`${pathname === link.href ? "font-bold" : ""}`}
                onClick={() => setISOpen(!isOpen)}
              >
                <span className="flex gap-4 items-center mb-7">
                  <Image src={link.icon} alt={link.label} height={30} width={30} />
                  {link.label}
                </span>
              </Link>
            </li>
          ))}

          {/* Mobile MBBS Dropdown */}
          <li className="relative" ref={mobileMbbsRef}>
            <button
              onClick={toggleMbbs}
              className="flex items-center space-x-2 hover:font-bold mb-7 w-full"
            >
              <span className="flex gap-4 items-center">
                <Image src="/Home/blogs.svg" alt="icon" height={30} width={30} />MBBS
              </span>
              <FaChevronDown className={`transform transition-transform ${mbbsdrop ? 'rotate-180' : ''}`} />
            </button>
            {mbbsdrop && (
              <ul className="mt-2 pl-4 pr-2 space-y-2 text-sm text-white rounded-lg p-4 ">
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-abroad"
                    className={`${pathname === "/study-mbbs-abroad" ? "font-bold underline" : ""}`}
                  >
                    Study MBBS Abroad
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-in-russia"
                    className={`${pathname === "/study-mbbs-in-russia" ? "font-bold underline" : ""}`}
                  >
                    MBBS in Russia
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-in-georgia"
                    className={`${pathname === "/study-mbbs-in-georgia" ? "font-bold underline" : ""}`}
                  >
                    MBBS in Georgia
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-in-australia"
                    className={`${pathname === "/study-mbbs-in-australia" ? "font-bold underline" : ""}`}
                  >
                    MBBS in Australia
                  </Link>
                </li>

                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-in-kyrgyzstan"
                    className={`${pathname === "/study-mbbs-in-kyrgyzstan" ? "font-bold underline" : ""}`}
                  >
                    MBBS in Kyrgyzstan
                  </Link>
                </li>

                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-in-usa"
                    className={`${pathname === "/study-mbbs-in-usa" ? "font-bold underline" : ""}`}
                  >
                    MBBS in USA
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-in-canada"
                    className={`${pathname === "/study-mbbs-in-canada" ? "font-bold underline" : ""}`}
                  >
                    MBBS in Canada
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-in-ukraine"
                    className={`${pathname === "/study-mbbs-in-ukraine" ? "font-bold underline" : ""}`}
                  >
                    MBBS in Ukraine
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-in-philippines"
                    className={`${pathname === "/study-mbbs-in-philippines" ? "font-bold underline" : ""}`}
                  >
                    MBBS in Philippines
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-in-kazakhstan"
                    className={`${pathname === "/study-mbbs-in-kazakhstan" ? "font-bold underline" : ""}`}
                  >
                    MBBS in  Kazakhstan
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-in-china"
                    className={`${pathname === "/study-mbbs-in-china" ? "font-bold underline" : ""}`}
                  >
                    MBBS in China
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-in-bangladesh"
                    className={`${pathname === "/study-mbbs-in-bangladesh" ? "font-bold underline" : ""}`}
                  >
                    MBBS in Bangladesh
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                  <Link
                    href="/study-mbbs-in-nepal"
                    className={`${pathname === "/study-mbbs-in-nepal" ? "font-bold underline" : ""}`}
                  >
                    MBBS in Nepal
                  </Link>

                  <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                    <Link
                      href="/study-mbbs-in-uzbekistan"
                      className={`${pathname === "/study-mbbs-in-uzbekistan" ? "font-bold underline" : ""}`}
                    >
                      MBBS in Uzbekistan
                    </Link>
                  </li>

                  <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                    <Link
                      href="/study-mbbs-in-poland"
                      className={`${pathname === "/study-mbbs-in-poland" ? "font-bold underline" : ""}`}
                    >
                      MBBS in Poland
                    </Link>
                  </li>


                  <li className="hover:font-bold" onClick={() => { setISOpen(false); setMbbsDrop(false); }}>
                    <Link
                      href="/study-mbbs-in-armenia"
                      className={`${pathname === "/study-mbbs-in-armenia" ? "font-bold underline" : ""}`}
                    >
                      MBBS in Armenia
                    </Link>
                  </li>

                </li>
              </ul>
            )}
          </li>

        <li className="relative" ref={mobileNursingRef}>
            <button
              onClick={toggleNursing}
              className="flex items-center space-x-2 hover:font-bold mb-7 w-full"
            >
              <span className="flex gap-4 items-center">
                <Image src="/Home/blogs.svg" alt="icon" height={30} width={30} />Nursing
              </span>
              <FaChevronDown className={`transform transition-transform ${nursingdrop ? 'rotate-180' : ''}`} />
            </button>
            {nursingdrop && (
              <ul className="mt-2 pl-4 pr-2 space-y-2 text-sm text-white rounded-lg p-4 ">
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setNursingDrop(false); }}>
                  <Link
                    href="/study-nursing-abroad"
                    className={`${pathname === "/study-nursing-abroad" ? "font-bold underline" : ""}`}
                  >
                    Study Nursing Abroad
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setNursingDrop(false); }}>
                  <Link
                    href="/bsc-nursing-in-canada"
                    className={`${pathname === "/bsc-nursing-in-canada" ? "font-bold underline" : ""}`}
                  >
                    Bsc Nursing in Canada
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setNursingDrop(false); }}>
                  <Link
                    href="/bsc-nursing-in-australia"
                    className={`${pathname === "/bsc-nursing-in-australia" ? "font-bold underline" : ""}`}
                  >
                    Bsc Nursing in Australia
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setNursingDrop(false); }}>
                  <Link
                    href="/bsc-nursing-in-ireland"
                    className={`${pathname === "/bsc-nursing-in-ireland" ? "font-bold underline" : ""}`}
                  >
                    Bsc Nursing in Ireland
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setNursingDrop(false); }}>
                  <Link
                    href="/bsc-nursing-in-uk"
                    className={`${pathname === "/bsc-nursing-in-uk" ? "font-bold underline" : ""}`}
                  >
                    Bsc Nursing in UK
                  </Link>
                  <li className="hover:font-bold" onClick={() => { setISOpen(false); setNursingDrop(false); }}>
                  <Link
                    href="/msc-nursing-in-canada"
                    className={`${pathname === "/bsc-nursing-in-canada" ? "font-bold underline" : ""}`}
                  >
                    Msc Nursing in Canada
                  </Link>
                </li>
                 <li className="hover:font-bold" onClick={() => { setISOpen(false); setNursingDrop(false); }}>
                  <Link
                    href="/msc-nursing-in-australia"
                    className={`${pathname === "/msc-nursing-in-australia" ? "font-bold underline" : ""}`}
                  >
                    Msc Nursing in Australia
                  </Link>
                </li>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setNursingDrop(false); }}>
                  <Link
                    href="/msc-nursing-in-ireland"
                    className={`${pathname === "/msc-nursing-in-ireland" ? "font-bold underline" : ""}`}
                  >
                    Msc Nursing in Ireland
                  </Link>
                </li>
                 <li className="hover:font-bold" onClick={() => { setISOpen(false); setNursingDrop(false); }}>
                  <Link
                    href="/msc-nursing-in-uk"
                    className={`${pathname === "/msc-nursing-in-uk" ? "font-bold underline" : ""}`}
                  >
                    Msc Nursing in UK
                  </Link>
                </li>
              </ul>
            )}
        </li>

         <li className="relative" ref={mobilePharmacyRef}>
            <button
              onClick={togglePharmacy}
              className="flex items-center space-x-2 hover:font-bold mb-7 w-full"
            >
              <span className="flex gap-4 items-center">
                <Image src="/Home/blogs.svg" alt="icon" height={30} width={30} />Pharmacy
              </span>
              <FaChevronDown className={`transform transition-transform ${pharmacydrop ? 'rotate-180' : ''}`} />
            </button>
            {pharmacydrop && (
              <ul className="mt-2 pl-4 pr-2 space-y-2 text-sm text-white rounded-lg p-4 ">
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setPharmacyDrop(false); }}>
                  <Link
                    href="/study-pharmacy-abroad"
                    className={`${pathname === "/study-pharmacy-abroad" ? "font-bold underline" : ""}`}
                  >
                    Study Pharmacy Abroad
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setPharmacyDrop(false); }}>
                  <Link
                    href="/bpharm-in-new-zealand"
                    className={`${pathname === "/bpharm-in-new-zealand" ? "font-bold underline" : ""}`}
                  >
                    B Pharm in New Zealand
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setPharmacyDrop(false); }}>
                  <Link
                    href="/bpharm-in-australia"
                    className={`${pathname === "/bpharm-in-australia" ? "font-bold underline" : ""}`}
                  >
                    B Pharm in Australia
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setPharmacyDrop(false); }}>
                  <Link
                    href="/bpharm-in-canada"
                    className={`${pathname === "/bpharm-in-canada" ? "font-bold underline" : ""}`}
                  >
                    B Pharm in Canada
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setPharmacyDrop(false); }}>
                  <Link
                    href="/pharmacy-in-ireland"
                    className={`${pathname === "/pharmacy-in-ireland" ? "font-bold underline" : ""}`}
                  >
                    Study Pharmacy in Ireland
                  </Link>
                  <Link
                    href="/mpharm-in-new-zealand"
                    className={`${pathname === "/mpharm-in-new-zealand" ? "font-bold underline" : ""}`}
                  >
                    M Pharm in New Zealand
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setPharmacyDrop(false); }}>
                  <Link
                    href="/mpharm-in-australia"
                    className={`${pathname === "/mpharm-in-australia" ? "font-bold underline" : ""}`}
                  >
                    M Pharm in Australia
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setPharmacyDrop(false); }}>
                  <Link
                    href="/mpharm-in-canada"
                    className={`${pathname === "/mpharm-in-canada" ? "font-bold underline" : ""}`}
                  >
                    M Pharm in Canada
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setPharmacyDrop(false); }}>
                  <Link
                    href="/mpharm-in-the-UK"
                    className={`${pathname === "/mpharm-in-the-UK" ? "font-bold underline" : ""}`}
                  >
                    M Pharm in UK
                  </Link>
                  </li>
                   <li className="hover:font-bold" onClick={() => { setISOpen(false); setPharmacyDrop(false); }}>
                  <Link
                    href="/ospap-course-uk"
                    className={`${pathname === "/ospap-course-uk" ? "font-bold underline" : ""}`}
                  >
                   OSPAP Postgraduate Course in UK
                  </Link>
                  </li>
              </ul>
            )}
        </li>
          {/* Mobile Others Dropdown */}
          <li className="relative" ref={mobileOthersRef}>
            <button
              onClick={toggleOthers}
              className="flex items-center space-x-2 hover:font-bold w-full"
            >
              <span className="flex gap-4 items-center">
                <Image src="/Home/blogs.svg" alt="icon" height={30} width={30} />Others
              </span>
              <FaChevronDown className={`transform transition-transform ${othersDrop ? 'rotate-180' : ''}`} />
            </button>
            {othersDrop && (
              <ul className="mt-2 pl-4 pr-2 space-y-2 text-sm text-white rounded-lg p-4 ">
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setOthersDrop(false); }}>
                  <Link
                    href="/blogs"
                    title="Blogs"
                    className={`${pathname === "/blogs" ? "font-bold underline" : ""}`}
                  >
                    Blogs
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setOthersDrop(false); }}>
                  <Link
                    href="/faqs"
                    className={`${pathname === "/faqs" ? "font-bold underline" : ""}`}
                  >
                    FAQs
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setOthersDrop(false); }}>
                  <Link
                    href="/about-us"
                    className={`${pathname === "/about-us" ? "font-bold underline" : ""}`}
                  >
                    About Us
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setOthersDrop(false); }}>
                  <Link
                    href="/neet-rank-predictor"
                    className={`${pathname === "/neet-rank-predictor" ? "font-bold underline" : ""}`}
                  >
                    NEET Rank Predictor
                  </Link>
                </li>
                <li className="hover:font-bold" onClick={() => { setISOpen(false); setOthersDrop(false); }}>
                  <Link
                    href="/contact-us"
                    className={`${pathname === "/contact-us" ? "font-bold underline" : ""}`}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            )}
          </li>
        </ul>
      </div >

      {/* Desktop Navigation */}
      <ul className="hidden xl:flex items-center max-lg:space-x-6 space-x-8 text-gray-700" >
        {
          [
            { href: "/", label: "Home" },
            { href: "/courses", label: "Courses" },
            { href: "/destination", label: "Destination" },
            { href: "/neet-result-2025", label: "NEET Exam 2025" },
          ].map((link) => (
            <li key={link.href}>
              <Link
                href={link.href}
                title={link.label}
                className={`hover:text-teal-600 ${pathname === link.href ? "text-teal-500 font-semibold" : ""}`}
              >
                {link.label}
              </Link>
            </li>
          ))
        }

        {/* Desktop MBBS Dropdown */}
        <li className="relative ">
          <div ref={dropdownRef}>
            <button
              onClick={toggleDropdown}
              className="flex items-center space-x-2 hover:text-teal-500"
            >
              <span>MBBS</span>
              <FaChevronDown className={`transform transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
            </button>
            {dropdownOpen && (
              <ul className="absolute top-[42px] !text-xs  left-[-50px] w-48 bg-white text-black shadow-md rounded-lg mt-2 border border-gray-200">
                <Link href="/study-mbbs-abroad" onClick={toggleDropdown}>      <li className="px-4 py-2 hover:bg-teal-500 font-bold hover:text-white hover:rounded-t-lg">

                  Study MBBS Abroad

                </li>     </Link>
                <Link href="/study-mbbs-in-russia" onClick={toggleDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  MBBS in Russia

                </li>   </Link>
                <Link href="/study-mbbs-in-georgia" onClick={toggleDropdown}>   <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  MBBS in Georgia

                </li>      </Link>
                <Link href="/study-mbbs-in-australia" onClick={toggleDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">

                  MBBS in Australia

                </li>     </Link>
                <Link href="/study-mbbs-in-kyrgyzstan" onClick={toggleDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">

                  MBBS in Kyrgyzstan

                </li>   </Link>


                <Link href="/study-mbbs-in-usa" onClick={toggleDropdown}>    <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">

                  MBBS in USA

                </li>    </Link>
                <Link href="/study-mbbs-in-canada" onClick={toggleDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">

                  MBBS in Canada

                </li>  </Link>
                <Link href="/study-mbbs-in-ukraine" onClick={toggleDropdown}>    <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">

                  MBBS in Ukraine

                </li>     </Link>
                <Link href="/study-mbbs-in-philippines" onClick={toggleDropdown}>   <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">

                  MBBS in Philippines

                </li>   </Link>
                <Link href="/study-mbbs-in-kazakhstan" onClick={toggleDropdown}> <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">

                  MBBS in Kazakhstan

                </li> </Link>
                <Link href="/study-mbbs-in-china" onClick={toggleDropdown}> <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">

                  MBBS in China

                </li> </Link>
                <Link href="/study-mbbs-in-bangladesh" onClick={toggleDropdown}> <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">

                  MBBS in Bangladesh

                </li> </Link>


                <Link href="/study-mbbs-in-nepal" onClick={toggleDropdown}> <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">

                  MBBS in Nepal

                </li> </Link>


                <Link href="/study-mbbs-in-uzbekistan" onClick={toggleDropdown}>   <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  MBBS in Uzbekistan

                </li>      </Link>


                <Link href="/study-mbbs-in-poland" onClick={toggleDropdown}>   <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  MBBS in Poland

                </li>      </Link>


                <Link href="/study-mbbs-in-armenia" onClick={toggleDropdown}>   <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  MBBS in Armenia

                </li></Link>





              </ul>
            )}
          </div>
        </li>

          <li className="relative ">
          <div ref={dropdownNursingRef}>
            <button
              onClick={toggleNursingDropdown}
              className="flex items-center space-x-2 hover:text-teal-500"
            >
              <span>Nursing</span>
              <FaChevronDown className={`transform transition-transform ${dropdownNursingOpen ? 'rotate-180' : ''}`} />
            </button>
            {dropdownNursingOpen && (
              <ul className="absolute top-[42px] !text-xs  left-[-50px] w-48 bg-white text-black shadow-md rounded-lg mt-2 border border-gray-200">
                <Link href="/study-nursing-abroad" onClick={toggleNursingDropdown}>      <li className="px-4 py-2 hover:bg-teal-500 font-bold hover:text-white hover:rounded-t-lg">

                  Study Nursing Abroad

                </li>
              </Link>
               <Link href="/bsc-nursing-in-canada" onClick={toggleNursingDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  Bsc Nursing in Canada

                </li>   </Link>
                 <Link href="/bsc-nursing-in-australia" onClick={toggleNursingDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  Bsc Nursing in Australia

                </li>   </Link>
                 <Link href="/bsc-nursing-in-ireland" onClick={toggleNursingDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  Bsc Nursing in Ireland

                </li>   </Link>
                 <Link href="/bsc-nursing-in-uk" onClick={toggleNursingDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  Bsc Nursing in UK

                </li>   </Link>
                 <Link href="/msc-nursing-in-canada" onClick={toggleNursingDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  Msc Nursing in Canada

                </li>   </Link>
                 <Link href="/msc-nursing-in-australia" onClick={toggleNursingDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  Msc Nursing in Australia

                </li>   </Link>
                 <Link href="/msc-nursing-in-ireland" onClick={toggleNursingDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  Msc Nursing in Ireland

                </li>   </Link>
                 <Link href="/msc-nursing-in-uk" onClick={toggleNursingDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  Msc Nursing in UK

                </li>   </Link>
              </ul>
            )}
          </div>
        </li>

     <li className="relative ">
          <div ref={dropdownPharmacyRef}>
            <button
              onClick={togglePharmacyDropdown}
              className="flex items-center space-x-2 hover:text-teal-500"
            >
              <span>Pharmacy</span>
              <FaChevronDown className={`transform transition-transform ${dropdownPharmacyOpen ? 'rotate-180' : ''}`} />
            </button>
            {dropdownPharmacyOpen && (
              <ul className="absolute top-[42px] !text-xs  left-[-50px] w-48 bg-white text-black shadow-md rounded-lg mt-2 border border-gray-200">
                <Link href="/study-pharmacy-abroad" onClick={togglePharmacyDropdown}>      <li className="px-4 py-2 hover:bg-teal-500 font-bold hover:text-white hover:rounded-t-lg">

                  Study Pharmacy Abroad

                </li>
              </Link>
               <Link href="/bpharm-in-new-zealand" onClick={togglePharmacyDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  B Pharm in New Zealand

                </li>   </Link>
                 <Link href="/bpharm-in-australia" onClick={togglePharmacyDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  B Pharm in Australia

                </li>   </Link>
                 <Link href="/pharmacy-in-ireland" onClick={togglePharmacyDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                Study Pharmacy in Ireland

                </li>   </Link>
                 <Link href="/bpharm-in-canada" onClick={togglePharmacyDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  B Pharm in Canada

                </li>   </Link>
                 <Link href="/mpharm-in-new-zealand" onClick={togglePharmacyDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  M Pharm in New Zealand

                </li>   </Link>
                 <Link href="/mpharm-in-australia" onClick={togglePharmacyDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  M Pharm in Australia

                </li>   </Link>
                 <Link href="/mpharm-in-canada" onClick={togglePharmacyDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                  M Pharm in Canada

                </li>   </Link>
                 <Link href="/mpharm-in-the-UK" onClick={togglePharmacyDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                 M Pharm in UK

                </li>   </Link>
                <Link href="/ospap-course-uk" onClick={togglePharmacyDropdown}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">

                OSPAP Postgraduate Course in UK

                </li>   </Link>
              </ul>
            )}
          </div>
        </li>
      </ul >

      <div className="flex justify-between items-center sm:gap-x-5">
        <a href="https://academically.com/" target="_blank" rel="noopener noreferrer" title="Licensing exam">
          <button className="bg-teal-500 border border-teal-500 hover:text-teal-500 hover:bg-white text-white px-4 py-2 rounded-md max-xl:scale-75" style={{ boxShadow: '5px 5px 2px rgba(0, 0, 0, 0.2)' }}>
            Licensing exam
          </button>
        </a>
        <button
          id={id}
          onClick={() => setIsModalOpen(true)}
          className={`px-2 max-xl:scale-75 py-1 sm:px-4 sm:py-2 text-sm font-medium text-teal-500 border border-teal-500 rounded hover:bg-teal-500 hover:text-white ${ismbbs ? "apply-mbbs" : "apply-default"}`}
          style={{ boxShadow: '5px 5px 2px rgba(0, 0, 0, 0.2)' }}
        >
          Apply now
        </button>

        {/* Desktop Others Dropdown */}
        <div className="relative max-xl:hidden" ref={desktopOthersRef}>
          <button
            onClick={toggleNew}
            className="flex items-center space-x-1 hover:text-teal-500"
          >

            <FaChevronDown className={`transform transition-transform ${dropdownNew ? 'rotate-180' : ''}`} />
          </button>
          {dropdownNew && (
            <ul className="absolute top-[40px] right-[-10px] w-48 bg-white text-black shadow-md rounded-lg mt-2 border border-gray-200">
              <Link href="/blogs" title="Blogs" onClick={toggleNew}>    <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-t-lg">
                Blogs
              </li></Link>
              <Link href="/faqs" title="FAQ" onClick={toggleNew}>  <li className="px-4 py-2 hover:bg-teal-500 hover:text-white">
                FAQ
              </li></Link>
              <Link href="/about-us" title="About Us" onClick={toggleNew}>     <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">
                About Us
              </li></Link>
              <Link href="/neet-rank-predictor" title="NEET Rank Predictor" onClick={toggleNew}> <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">
                NEET Rank Predictor
              </li></Link>
              <Link href="/contact-us" onClick={toggleNew} title="Contact Us">   <li className="px-4 py-2 hover:bg-teal-500 hover:text-white hover:rounded-b-lg">
                Contact Us
              </li></Link>
            </ul>
          )}
        </div>

        <ModalForm isOpen={isModalOpen} setISOpen={setIsModalOpen} />
      </div>
    </nav >
  );
};

export default Header;